import { render, staticRenderFns } from "./ProjectSidebarIndex.vue?vue&type=template&id=2ebe5eb1&scoped=true"
import script from "./ProjectSidebarIndex.vue?vue&type=script&lang=js"
export * from "./ProjectSidebarIndex.vue?vue&type=script&lang=js"
import style0 from "./ProjectSidebarIndex.vue?vue&type=style&index=0&id=2ebe5eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe5eb1",
  null
  
)

export default component.exports